import React from 'react';
import styled from 'styled-components';
import { func, string, oneOfType, element, bool } from 'prop-types';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import Container from '../Container/Container';
import Wrapper from '../Wrapper';
import Button from '../Button';
import { SubBodyText, H2 } from '../Text/Heading';

import { ROUTE } from '../../utils/constants';

const SummaryWrapper = styled(Wrapper)`
  background-color: ${({ theme }) => theme.colors.greyLighter};
  height: 136px;
`;

const SummaryContainer = styled(Container)`
  display: flex;
  padding: 56px 0 51px 0;
`;

const SubTitle = styled(SubBodyText)`
  color: ${({ theme }) => theme.colors.greyDark};
`;
SubTitle.displayName = 'SubTitle';

const SummaryHeader = ({
  title,
  subTitle,
  onEditSearch,
  editSearchUrl,
  showEditButton,
}) => {
  return (
    <SummaryWrapper id="booking-summary" display={['none', 'block']}>
      <SummaryContainer>
        <Wrapper width={[1, 2 / 3, 1 / 2]}>
          <H2 lineHeight="31px" id="summary-title">
            {title}
          </H2>
          <SubTitle id="summary-details">{subTitle}</SubTitle>
        </Wrapper>
        {showEditButton && (
          <Wrapper
            width={[1, 1 / 3, 1 / 2]}
            display={'flex'}
            flexDirection={'row-reverse'}
          >
            <a href={editSearchUrl ? editSearchUrl : ROUTE.ROOT}>
              <Button id="edit-search-btn" secondary onClick={onEditSearch}>
                {translate('summaryHeader.editSearch')}
              </Button>
            </a>
          </Wrapper>
        )}
      </SummaryContainer>
    </SummaryWrapper>
  );
};

SummaryHeader.propTypes = {
  title: oneOfType([string, element]).isRequired,
  subTitle: oneOfType([string, element]).isRequired,
  onEditSearch: func,
  editSearchUrl: string,
  showEditButton: bool,
};

SummaryHeader.defaultProps = {
  showEditButton: true,
};

export default SummaryHeader;
